import { constants } from "../constants/redux-constants";

const initialState = {
  selectedTab: {},
  showPopup: false,
  selectedTemplate: {},
  cdssRegenObject: {},
  navigate: "",
  autoStart: false,
  showSubscriptionPopup: false,
  showExceededSubscriptionPopup: false,
  mobileCollapse: "",
  persistEncID: true,
};

const scribeReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SCRIBE.SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case constants.SCRIBE.SET_SUBSCRIPTION_POPUP:
      return {
        ...state,
        showSubscriptionPopup: action.payload,
      };
    case constants.SCRIBE.SET_EXCEEDED_SUBSCRIPTION_POPUP:
      return {
        ...state,
        showExceededSubscriptionPopup: action.payload,
      };
    case constants.SCRIBE.SHOW_POPUP:
      return {
        ...state,
        showPopup: action.payload,
        navigate: action.route,
      };
    case constants.SCRIBE.SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplate: action.payload,
      };
    case constants.SCRIBE.AUTO_START:
      return {
        ...state,
        autoStart: action.payload,
      };
    case constants.SCRIBE.CDSS_REGEN_OBJ:
      return {
        ...state,
        cdssRegenObject: action.payload,
      };
    case constants.SCRIBE.SET_MOBILE_COLLAPSE:
      return {
        ...state,
        mobileCollapse: action.payload,
      };
    case constants.SCRIBE.SET_PERSIST_ENC_ID:
      return {
        ...state,
        persistEncID: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default scribeReducer;
